/**
 * Service to handle API calls for Project
 */
import axios from "../services/axiosService.js";
import CommonService from "../services/commonService.js";

//  Mock data imports
import dataProjects from '../assets/data/projects.json';

class ProjectService {
  commonService = new CommonService();
  constructor() {

    this.apiPointer = process.env.REACT_APP_WEB_API_POINTER;
    this.apiHostEnv = process.env.REACT_APP_HOSTING_ENV;

    this.webApiEndpoint = process.env.REACT_APP_WEB_API_ENDPOINT;
    this.webApiFolder = process.env.REACT_APP_WEB_API_FOLDER;
    this.webApiEndpointAU = process.env.REACT_APP_WEB_API_ENDPOINT_AU;
    this.webApiEndpointEU = process.env.REACT_APP_WEB_API_ENDPOINT_EU;
    this.webApiEndpointUS = process.env.REACT_APP_WEB_API_ENDPOINT_US;

    //  List of API endpoints to point to local mock data
    this.mockApiUrl = [
      //  'GetProjectMasterData',
    ];
  }

  /**
   * This method gets all the projects user has access to.
   * @returns Array of projects
   */
  GetProjectMasterData = async (email, country) => {
    const payload = {
      email: email,
      country: country
    }
    try {
      if (
        this.apiPointer.toLowerCase() === "local" ||
        this.mockApiUrl.includes("GetProjectMasterData")
      ) {
        return Promise.resolve(dataProjects);
      } else {
        if (this.apiHostEnv === "UAT" || this.apiHostEnv === "PROD") {
          const apiUrlAU = this.webApiEndpointAU + this.webApiFolder;
          const apiUrlEU = this.webApiEndpointEU + this.webApiFolder;
          const apiUrlUS = this.webApiEndpointUS + this.webApiFolder;
          let dataAll = [];
          const dataAU = await axios.post(apiUrlAU + "/Project/GetProjectMasterData", payload).then(response => response?.data).catch(() => []);
          const dataEU = await axios.post(apiUrlEU + "/Project/GetProjectMasterData", payload).then(response => response?.data).catch(() => []);
          const dataUS = await axios.post(apiUrlUS + "/Project/GetProjectMasterData", payload).then(response => response?.data).catch(() => []);
          if (dataAU) {
            dataAll = [...dataAll, ...dataAU];
          }
          if (dataEU) {
            dataAll = [...dataAll, ...dataEU];
          }
          if (dataUS) {
            dataAll = [...dataAll, ...dataUS];
          }
          return dataAll;
        } else {
          const apiUrl = this.webApiEndpoint + this.webApiFolder;
          const data = await axios.post(apiUrl + "/Project/GetProjectMasterData", payload).then(response => response?.data);
          return data;
        }
      }
    } catch (error) {
      this.commonService.logException(
        error,
        "projectService",
        "GetProjectMasterData"
      );
    }
  }
}

export default ProjectService;